__turbopack_context__.v({
  "amount": "CalcHeader-module-scss-module__gqWMKa__amount",
  "amountDigit": "CalcHeader-module-scss-module__gqWMKa__amountDigit",
  "amountDigitFace": "CalcHeader-module-scss-module__gqWMKa__amountDigitFace",
  "amountDigitRolling": "CalcHeader-module-scss-module__gqWMKa__amountDigitRolling",
  "amountDigitTrack": "CalcHeader-module-scss-module__gqWMKa__amountDigitTrack",
  "amountSeparator": "CalcHeader-module-scss-module__gqWMKa__amountSeparator",
  "amountValue": "CalcHeader-module-scss-module__gqWMKa__amountValue",
  "container": "CalcHeader-module-scss-module__gqWMKa__container",
  "containerWarehouse": "CalcHeader-module-scss-module__gqWMKa__containerWarehouse",
  "content": "CalcHeader-module-scss-module__gqWMKa__content",
  "currency": "CalcHeader-module-scss-module__gqWMKa__currency",
  "digitRoll": "CalcHeader-module-scss-module__gqWMKa__digitRoll",
  "eyebrow": "CalcHeader-module-scss-module__gqWMKa__eyebrow",
  "fishIcon": "CalcHeader-module-scss-module__gqWMKa__fishIcon",
  "header": "CalcHeader-module-scss-module__gqWMKa__header",
  "intro": "CalcHeader-module-scss-module__gqWMKa__intro",
  "introText": "CalcHeader-module-scss-module__gqWMKa__introText",
  "summary": "CalcHeader-module-scss-module__gqWMKa__summary",
  "summaryDescription": "CalcHeader-module-scss-module__gqWMKa__summaryDescription",
  "summaryLabel": "CalcHeader-module-scss-module__gqWMKa__summaryLabel",
  "summaryNote": "CalcHeader-module-scss-module__gqWMKa__summaryNote",
  "title": "CalcHeader-module-scss-module__gqWMKa__title",
});
